import { Toast } from 'bootstrap';

export const toastTypes = Object.freeze({
  DEFAULT: 'default',
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info',
});

const typeClassMap = {
  default: 'bg-white',
  success: 'text-bg-success text-white',
  warning: 'text-bg-warning',
  danger: 'text-bg-danger',
  info: 'text-bg-info',
};

export const showToast = (type, message, placement) => {
  const container = createToastContainer(placement);
  const toast = createToast(type, message);
  container.appendChild(toast);

  toast.addEventListener('hidden.bs.toast', () => {
    container.remove();
  });

  const toastBootstrap = Toast.getOrCreateInstance(toast);
  toastBootstrap.show();
};

const createToastContainer = (containerPlacement = 'bottom-0 end-0') => {
  const container = document.createElement('div');
  container.className = `toast-container position-fixed ${containerPlacement} p-3`;
  document.body.appendChild(container);

  return container;
};

const createToast = (type, message) => {
  const toast = document.createElement('div');
  toast.className = 'toast shadow-sm';
  toast.setAttribute('role', 'alert');
  toast.setAttribute('aria-live', 'assertive');
  toast.setAttribute('aria-atomic', 'true');

  const extraClasses = typeClassMap[type || toastTypes.default];

  const toastBody = document.createElement('div');
  toastBody.className = `toast-body text-center rounded-2 ${extraClasses}`;
  toastBody.innerText = message;
  toast.appendChild(toastBody);

  return toast;
};
